import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';

type UploadProgressBarProps = {
  progress: number;
};

const ProgressBar = styled.div`
  background-color: ${theme.colors.neutrals.solidGrays[2]};
  bottom: 0;
  height: 4px;
  left: 0;
  position: absolute;
  width: 100%;
`;

const Fluid = styled.div<UploadProgressBarProps>`
  background-color: ${theme.colors.system.systemGreen};
  height: 100%;
  transition: width 0.2s;
  width: ${({ progress }) => progress}%;
  z-index: 1;
`;

export const UploadProgressBar: React.FC<UploadProgressBarProps> = ({
  progress,
}) => (
  <ProgressBar>
    <Fluid progress={progress} />
  </ProgressBar>
);
